import { useAuthStore } from "@/stores/auth-store";
import type { AxiosInstance } from "axios";
import axios from "axios";

export interface AxiosFactory {
  withToken: () => AxiosInstance;
  withoutToken: () => AxiosInstance;
}

export class axiosFactory implements AxiosFactory {
  withToken(): AxiosInstance {
    const token = JSON.parse(localStorage.getItem("token") || "");
    const reqInstance = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return reqInstance;
  }

  withoutToken(): AxiosInstance {
    const reqInstance = axios.create({
    });
    const authStore = useAuthStore();

    reqInstance.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data      
      //console.log('Axious Interceptor [Success]:', response);
      return response;
    }, async function (error) {
      await authStore.authenticate();
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    });
    return reqInstance;
  }
}